import { useState } from "react";
import { Share2, Check, MessageCircle } from "lucide-react";
import { toast } from "sonner";

const fmtDay = (iso) => new Date(`${iso}T12:00:00`).toLocaleDateString("de-DE", { weekday: "long", day: "2-digit", month: "2-digit" });
const fmtShort = (iso) => new Date(`${iso}T12:00:00`).toLocaleDateString("de-DE", { weekday: "short", day: "2-digit", month: "2-digit" });

export const shareUrl = (item) => {
  const q = new URLSearchParams({ thema: "einsteiger", kurs: item.name, termin: `${fmtShort(item.date)} · ${item.start_time} Uhr · ${item.name}`, datum: item.date, von: "freund" });
  return `${window.location.origin}/?${q.toString()}#kontakt`;
};
const shareText = (item) => `Komm mit zu ${item.name} am ${fmtDay(item.date)} um ${item.start_time} Uhr bei FlensFitness! Dein erstes Training ist kostenlos – hier mit einem Klick anfragen:`;
const waHref = (item) => `https://wa.me/?text=${encodeURIComponent(`${shareText(item)} ${shareUrl(item)}`)}`;

export const ShareButton = ({ item, compact = false, className = "" }) => {
  const [copied, setCopied] = useState(false);
  const share = async (e) => {
    e.stopPropagation();
    const url = shareUrl(item); const text = shareText(item);
    if (navigator.share) {
      try { await navigator.share({ title: `${item.name} bei FlensFitness`, text, url }); return; } catch (err) { if (err?.name === "AbortError") return; }
    }
    window.open(waHref(item), "_blank", "noopener");
  };
  const copy = async (e) => {
    e.stopPropagation();
    try {
      await navigator.clipboard.writeText(`${shareText(item)} ${shareUrl(item)}`);
      setCopied(true); setTimeout(() => setCopied(false), 2000);
      toast.success("Link kopiert – schick ihn deinen Freunden.");
    } catch { window.open(waHref(item), "_blank", "noopener"); }
  };
  if (compact) {
    return (
      <button type="button" onClick={share} data-testid="kursplan-slot-share" aria-label={`${item.name} ${item.start_time} per WhatsApp an Freunde schicken`}
        className={`tap inline-flex items-center gap-1.5 min-h-[44px] lg:min-h-0 text-sm lg:text-xs font-semibold text-[#3A3A3E] hover:text-[#25D366] transition-colors ${className}`}>
        <MessageCircle size={12} className="shrink-0 lg:w-4 lg:h-4" /><span className="whitespace-nowrap lg:hidden">Freund:in einladen</span>
      </button>
    );
  }
  return (
    <div className={`flex flex-wrap gap-2 ${className}`}>
      <a href={waHref(item)} target="_blank" rel="noopener noreferrer" data-testid="course-dialog-whatsapp" className="btn-ghost !text-sm justify-center"><MessageCircle size={15} />Per WhatsApp einladen</a>
      <button type="button" onClick={copy} data-testid="course-dialog-share" className="btn-ghost !text-sm justify-center">{copied ? <Check size={15} /> : <Share2 size={15} />}{copied ? "Link kopiert" : "Link kopieren"}</button>
    </div>
  );
};
